export default {
  termsDescription: {
    id: 'insurances_options_biennial_terms_description',
    defaultMessage:
      'I understand that my 24-month Protection plan will renew automatically every 2 years, and I agree that my payment method will be charged each billing cycle until I cancel. I can cancel anytime {faqLink, html}',
  },
  faqLinkLabel: {
    id: 'insurances_options_biennial_faq_link_content',
    defaultMessage: 'through my account',
  },
  faqLinkValue: {
    id: 'insurances_options_biennial_faq_link_value',
    defaultMessage:
      'https://help.backmarket.com/hc/en-us/articles/4404019304594-Can-I-cancel-my-Protection-Plan',
  },
  termsLinkContent: {
    id: 'insurances_options_biennial_terms_link_content',
    defaultMessage: 'Terms and Conditions',
  },
}
